export const searchFilter = (input: string, searchValues: (string | undefined | null)[]) => {
  if (!searchValues.length) {
    return false;
  }

  const inputWords = input.toLowerCase().split(/\s+/);
  const searchValue = searchValues
    .filter((value): value is string => value !== undefined && value !== null)
    .map((value) => String(value).toLowerCase())
    .join(' ');

  return inputWords.every((word) => searchValue.includes(word));
};
